import { getUserId } from 'utils/localstore';
import { Request } from '../request';

export const getMeetingInfoLocalServer = (name: string, topic: string) =>
    Request.post({
        url: 'http://localhost:4000/api/meeting',
        params: { name, topic },
        disableErrorNote: true,
    });

export const waitingJoin = (sessionKey: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/waiting/join`,
    });

export const waitingRenew = (sessionKey: string, userUuid: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/waiting/renew`,
        params: {
            userUuid,
        },
        disableErrorNote: true,
    });

export const meetingStart = (sessionKey: string, userUuid: string, fullName: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/start`,
        params: {
            userUuid,
            fullName,
        },
    });

export const meetingJoin = (sessionKey: string, userUuid: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/join`,
        params: {
            userUuid,
        },
    });

export const meetingRenew = (sessionKey: string, userUuid: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/renew`,
        params: {
            userUuid,
        },
        disableErrorNote: true,
    });

export const meetingToken = (sessionKey: string, userUuid: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/token`,
        params: {
            userUuid,
        },
    });

export const meetingApprove = (sessionKey: string, userUuid: string, patientUserId: number) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/approve`,
        params: {
            userUuid,
            patientUserId,
        },
    });

export const providerUpdateVideoAudio = (
    sessionKey: string,
    userUuid: string,
    isAudioOn: boolean,
    isVideoOn: boolean,
) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/video-audio/update`,
        params: {
            userUuid,
            isAudioOn,
            isVideoOn,
        },
    });
//not use in bp
export const patientUpdateVideoAudio = (sessionKey: string, userUuid: string, isAudioOn: boolean, isVideoOn: boolean) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/video-audio/update`,
        params: {
            userUuid,
            isAudioOn,
            isVideoOn,
        },
    });

/**
 * 创建会议房间
 * 如果 provider 之前创建过未被使用的会议房间（business_id 和 business_type 为空），则返回已有的 sessionKey；
 * 否则生成新的 key（格式：MR + 10位编码）
 * @returns {Promise} 返回 { meetingUrl: string, sessionKey: string }
 */
export const createMeetingRoom = () =>
    Request.post<{ meetingUrl: string; sessionKey: string }>({
        url: '/schedule-server/provider/meeting-room/create',
    });

export const meetingKick = (sessionKey: string, userUuid: string, patientUserId: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/kick`,
        params: {
            userUuid,
            patientUserId,
        },
    });

export const meetingEnd = (sessionKey: string) =>
    Request.post({
        url: `/schedule-server/provider/meeting-room/${sessionKey}/end`,
    });

export const getUpcomingAppointmentDetail = (appointmentId: number) =>
    Request.get({
        url: `/schedule-server/provider/appointment/next?appointmentId=${appointmentId}`,
    });

export type TReportErrorParams = {
    errorCode: string;
    message: string;
    pageUrl?: string | null;
    component?: string | null;
    severity?: string | null;
    environment?: string | null;
    browser?: string | null;
    os?: string | null;
    device?: string | null;
};

export const reportError = (param: TReportErrorParams) => {
    const data = { ...param };
    if (typeof window !== 'undefined') {
        data.pageUrl = window.location.href;
    }
    if (typeof window !== 'undefined') {
        data.browser = window.navigator.userAgent;
    }
    if (typeof window !== 'undefined') {
        data.os = window.navigator.userAgent;
    }
    if (typeof window !== 'undefined') {
        data.device = window.navigator.userAgent;
    }
    data.component = `${getUserId()}` || '';
    Request.post({
        url: `/schedule-server/public/frontend/error/log`,
        params: data,
        disableErrorNote: true,
    });
};
